(function () {
  function animateCount(element) {
    if (element.dataset.pjxAnimated === 'true') return;
    element.dataset.pjxAnimated = 'true';

    var original = element.dataset.pjxCountUp || element.textContent.trim();
    var match = original.match(/[\d,]+(?:\.\d+)?/);
    if (!match || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      element.textContent = original;
      return;
    }

    var target = Number(match[0].replace(/,/g, ''));
    var prefix = original.slice(0, match.index);
    var suffix = original.slice(match.index + match[0].length);
    var start = performance.now();
    var duration = 1100;

    function frame(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased).toLocaleString();
      element.textContent = prefix + value + suffix;
      if (progress < 1) requestAnimationFrame(frame);
    }

    requestAnimationFrame(frame);
  }

  function init() {
    var counters = document.querySelectorAll('[data-pjx-count-up]');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)) {
      counters.forEach(animateCount);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.35 });
    counters.forEach(function (counter) { observer.observe(counter); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
